import { ToolbarOptions } from "@zebrabi/global-toolbar-old/interface/ToolbarOption";
import BaseSwitcherWithHeaderOld from "./BaseSwitcherWithHeaderOld";

/** POC only: a toolbar button that puts the add-in instance back to the state of a fresh insert */
class ResetVisualSwitcher extends BaseSwitcherWithHeaderOld {
    static readonly CLASS_NAME = "ResetVisualSwitcher";

    toolbarOptions: ToolbarOptions = {
        actions: [],
        elementName: "Reset to default",
        icon: "reset-icon-base64",
        type: "button",
    };

    public getClassName(): string {
        return ResetVisualSwitcher.CLASS_NAME;
    }

    buttonAction(): void {
        return;
    }

    update(): void {
        return;
    }

    createMenuItems(): void {
        // a plain button: nothing to open
    }

    getScrollPosition(): number {
        return 0;
    }
}

export default ResetVisualSwitcher;
